import qs from 'qs';
import { createSelector } from 'reselect';
import { getCurrentLang } from '@src/containers/Session/selectors/getCurrentLang';
import getCurrentPaging from '@src/containers/Session/selectors/getCurrentPaging';
import getFiltersQuery from '@src/containers/Filters/selectors/getFiltersQuery';
import { getCity } from '@src/containers/Session/selectors/getCity';
import getSpacesListOrder from './getSpacesListOrder';

const getSeed = (store) => store.Session.seed;

export const loadSpacesParams = createSelector(
	getSeed,
	getCurrentLang,
	getCurrentPaging,
	getCity,
	getFiltersQuery,
	getSpacesListOrder,
	(seed, lang, pager, city, filters, order) => {
		const { page, perPage } = pager;
		const { id: cityId } = city;

		const filterQuery = encodeURI(
			qs.stringify(filters, { arrayFormat: 'comma' }),
		);

		const result = {
			list: {
				cityId,
				page,
				perPage,
				filters: filterQuery,
				seed,
				typeId: [3],
			},
			entity: {
				cityId,
				filters: filterQuery,
				languageId: lang.id || null,
				specId: filters.spec || 1,
			},
		};

		if (order && order !== 'popular') {
			result.list.order = order;
		}

		if (!filterQuery) {
			delete result.list.filters;
			delete result.entity.filters;
		}

		return result;
	},
);
